import axios from "axios"

//const
const USER_DETAILS_GET_INFO = "userDetails/USER_DETAILS_GET_INFO"
const USERINFO_DETAILS_GET_INFO = "userDetails/USERINFO_DETAILS_GET_INFO"
const USER_ENTERPRISE_ROLE_GET = "userDetails/USER_ENTERPRISE_ROLE_GET"
const REDIRECT_TO_ENTERPRISE_INFO = "userDetails/REDIRECT_TO_ENTERPRISE_INFO";

//reducer
export const userDetails = (state = {
  user: {
    username: "",
    email: "",
    phone: "",
    statusCode: null,
  },
  userinfo: {
    metadata:"",
    avatar:"",
  },
  companyAndRoleName: [],
  currentEnterpirse:"",
}
,action) => {
  switch (action.type) {
    case USER_DETAILS_GET_INFO:
      console.log("user: ", action.data)
      let newUserInfo = {
        username: action.data.username,
        email: action.data.email,
        phone: action.data.phone,
        statusCode: action.data.verifyStatus.code,

      }
      return {
        ...state,
          user: newUserInfo
      };


    case USERINFO_DETAILS_GET_INFO:
      console.log("userinfo: ", action.data)
      let userInfoUpdate = [];
      if (action.data.avatar === null || action.data.avatar === undefined) {
        userInfoUpdate = {
          metadata: action.data.metadata,
          avatar: "24dd932a187949579e35e8af7cfd352e.jpg", // user default logo
        }
      }else{
          userInfoUpdate = {
            metadata: action.data.metadata,
            avatar: action.data.avatar,
          }
        }

        return {
          ...state,
          userinfo: userInfoUpdate
        };

    case  USER_ENTERPRISE_ROLE_GET:
      console.log("enterpriseandrole",action.data)
      return {
        ...state,
        companyAndRoleName:action.data.map(value => {
          value.key = value.enterpriseName;
          value.newRoles = value.roles.map(v => {
            return v.name;
          });
          value.newRoles = value.newRoles.toString();
          return value;
          })
      };

    case REDIRECT_TO_ENTERPRISE_INFO:
      console.log("current",action.data)
      return {
        ...state,
        currentEnterprise: action.data.enterpriseId,
      };
    default:
      return state
  }
}

// action
export const getUserDetails = (userId) => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  let url = "/api-user/users?userId=" + userId;

  return axios({
    method: "GET",
    url: url,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log(response.data);
        dispatch(getUserDetailsDone(response.data))
      }
    })
}

export const getUserInfoDetails = (userId) => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  let url = "/api-user/userInfoes?userId=" + userId;

  return axios({
    method: "GET",
    url: url,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log(response.data);
        dispatch(getUserInfoDetailsDone(response.data))
      }
    })
}

export const getUserEnterpriseAndRole = (userId) => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  let url = "/api-user/users/" + userId +"/enterpriseProjections?enterpriseId=&applicationId="

  return axios({
    method: "GET",
    url: url,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("enterprise",response.data);
        dispatch(getUserEnterpriseAndRoleDone(response.data))
      }
    })
}

export const getUserEnterpriseAndRoleDone = (data) => {
  return {
    type: USER_ENTERPRISE_ROLE_GET,
    data: data
  }
}

export const getUserDetailsDone = (data) => {
  return {
    type: USER_DETAILS_GET_INFO,
    data: data
  }
}

export const getUserInfoDetailsDone = (datainfo) => {
  return {
    type: USERINFO_DETAILS_GET_INFO,
    data: datainfo
  }
}


export const toDetails = (name) => {
  return {
    type: REDIRECT_TO_ENTERPRISE_INFO,
    data: name
  };
}


